import React from 'react'
import ReactDom from 'react-dom'
import styled from 'styled-components'
const modalRoot = document.getElementById('modal') as HTMLElement

interface ModalProps {
    open: boolean,
    onClose: () => void
}

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .7);
    z-index: 1000
`

const Wrapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #FFF;
    padding: 50px;
    z-index: 1000
`

const Modal = ({ open, onClose }: ModalProps) => {
    if (!open) return null
    return ReactDom.createPortal(
        <>
            <Overlay />
            <Wrapper>
                modal
                <button onClick={onClose}>exit</button>
            </Wrapper>
        </>,
        modalRoot
    )
}

export default Modal;